// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WLQK","placeholdersHeader":"styles_placeholdersHeader__t5AjB","editorStyle":"styles_editorStyle__1IHLQ","placeholdersBox":"styles_placeholdersBox__208ym"};